module.exports = __webpack_public_path__ + "img/p-one-step-23.b42a3823.png";